import React from 'react'
import { CmsBlock } from 'lib/shared/__DEPRECATED__/CmsBlock'
import { CMS_BLOCK } from 'app/sofia/resources/constants'
import { Container } from './components/Styled'

export const Contact = () => {
  return (
    <Container>
      <CmsBlock
        id={CMS_BLOCK.FOOTER_CONTACT}
      >
        {({ isFailure, content }) => {
          if (isFailure) {
            if (!process.env.REACT_APP_ENABLE_CMS_BLOCK_SAMPLE_DATA) {
              return null
            }

            return (
              <SampleData />
            )
          }
          return (
            <div
              dangerouslySetInnerHTML={{
                __html: content
              }}
            />
          )
        }}
      </CmsBlock>
    </Container>
  )
}

const SampleData = () => {
  return (
    <>
      <h2>Contact</h2>
      <div>
        <a href='mailto:info@sofiaandgrace.com'>info@sofiaandgrace.com</a>
        <address>
          HDIS Inc. 9385 Dielman Ind. Dr. Olivette, MO 63132
          <a href='tel:8881231234'>888-123-1234</a>
        </address>
      </div>
      <a className='footer__button' href='/'>Join Private Group</a>
    </>
  )
}
